import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import { createMRTColumnHelper } from "material-react-table";
import { baseUrl } from "../../../helper/urls";

import MasterLayout from "../../../masterLayout/MasterLayout";
import CustomTable from "../../../components/custom_table/CustomTable";
import Swal from "sweetalert2";
import { Box, Button } from "@mui/material";
import moment from "moment-timezone";
const StudentReScheduledBookingList = () => {
  const { token } = useSelector((state) => state.auth);
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const RescheduledBookings = async () => {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    try {
      const response = await axios.get(
        `${baseUrl}/api/reschedule/student/list`,
        { headers }
      );
      const data = convertSlotsToStudentTimezone(response.data.data || []);

      // Add formattedReqId here
      const processedData = data.map((item) => ({
        ...item,
        formattedReqId: `DDR000${item.reqId || ""}`,
        counselorName: `${item.c_firstname || ""} ${item.c_lastname || ""
          }`.trim(),
      }));
      setBookings(processedData);

      setLoading(false);
    } catch (error) {
      console.error("Error fetching bookings:", error);
      setError("Failed to fetch bookings");
      setLoading(false);
    }
  };

  useEffect(() => {
    RescheduledBookings();
  }, []);



  const convertSlotsToStudentTimezone = (slots) => {
    const studentTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    return slots.map((slot) => {
      // const duration = slot.duration || 60;
      const startLocal = moment.utc(slot.utcTime).tz(studentTimeZone);
      const endLocal = moment(startLocal).add(slot.booking_duration, "minutes");
      console.log(slot.booking_duration);
      return {
        ...slot,
        booking_date: startLocal.format("YYYY-MM-DD"),
        // start_time: startLocal.format("hh:mm A"),
        // end_time: endLocal.format("hh:mm A"),
        time_zone: studentTimeZone,
      };
    });
  };

  const columnHelper = createMRTColumnHelper();
  const columns = [
    // columnHelper.accessor("counselorName", {
    //   header: "Counselor Name",
    // }),
    columnHelper.accessor("c_firstName", {
      header: "Counselor Name",
      Cell: (cell) => cell.row.original.c_firstName + " "+ cell.row.original.c_lastName,
    }),

    columnHelper.accessor("type", {
      header: "Service Type",
      size: 30,
      Cell: (cell) => cell.row.original.type,
    }),
    columnHelper.accessor("reason", {
      header: "Reason",
      size: 30,
      Cell: (cell) => cell.row.original.reason,
    }),
    columnHelper.accessor("booking_date", {
      header: "Slot Date (UTC)",
      size: 30,
      // Cell: (cell) => cell.row.original.booking_date,
      Cell: (cell) => cell.row.original.utcTime?.split("T")[0] || "N/A",
    }),

    columnHelper.accessor("formattedReqId", {
      header: "Request ID",
    }),
  ];

  columns.unshift(
    columnHelper.accessor("actions", {
      header: "Actions",
      Cell: ({ cell }) => {
        const id = cell.row.original.id;
        const status = cell.row.original.status;

        const handleApprove = () => {
          Swal.fire({
            html: `<div style="font-size: 30px; font-weight: bold;">Are you sure?</div>`,
            text: "Do you want to approve this reschedule request?",
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Yes, Approve",
            cancelButtonText: "Cancel",
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
          }).then((result) => {
            if (result.isConfirmed) {
              axios
                .get(`${baseUrl}/api/reschedule/student/approved/${id}`, {
                  headers: {
                    Authorization: `Bearer ${token}`, // assume token from session
                  },
                })
                .then((res) => {
                  Swal.fire(
                    "Approved!",
                    "Reschedule has been approved.",
                    "success"
                  );
                  RescheduledBookings(); // reload updated data
                })
                .catch((err) => {
                  Swal.fire(
                    "Error!",
                    err.response?.data?.message || "Failed to approve request.",
                    "error"
                  );
                });
            }
          });
        };

        return (
          <Box display="flex" alignItems="center" gap={1}>
            {status == 0 ? (
              <Button
                variant="contained"
                size="small"
                color="error"
                onClick={handleApprove}
                sx={{ textTransform: "none", p: 1 }}
              >
                Agree
                {/* Approve */}
              </Button>
            ) : (
              <span style={{ color: "green" }}>Approved</span>
            )}
          </Box>
        );
      },
    })
  );

  return (
    <MasterLayout>
      <CustomTable columns={columns} data={bookings} loading={loading} />
    </MasterLayout>
  );
};

export default StudentReScheduledBookingList;

// import React, { useState, useEffect } from "react";
// import { useSelector } from "react-redux";
// import axios from "axios";
// import { createMRTColumnHelper } from "material-react-table";
// import { baseUrl } from "../../../helper/urls";

// import MasterLayout from "../../../masterLayout/MasterLayout";
// import CustomTable from "../../../components/custom_table/CustomTable";
// import Swal from "sweetalert2";
// import { Box, Button } from "@mui/material";
// import moment from "moment-timezone";
// const StudentReScheduledBookingList = () => {
//   const { token } = useSelector((state) => state.auth);
//   const [bookings, setBookings] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   const RescheduledBookings = async () => {
//     const headers = {
//       "Content-Type": "application/json",
//       Authorization: `Bearer ${token}`,
//     };

//     try {
//       const response = await axios.get(
//         `${baseUrl}/api/reschedule/student/list`,
//         { headers }
//       );
//       const data = convertSlotsToStudentTimezone(response.data.data || []);

//       // Add formattedReqId here
//       const processedData = data.map((item) => ({
//         ...item,
//         formattedReqId: `DDR000${item.reqId || ""}`,
//         counselorName: `${item.c_firstname || ""} ${
//           item.c_lastname || ""
//         }`.trim(),
//       }));
//       setBookings(processedData);

//       setLoading(false);
//     } catch (error) {
//       console.error("Error fetching bookings:", error);
//       setError("Failed to fetch bookings");
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     RescheduledBookings();
//   }, []);

//   const convertSlotsToStudentTimezone = (slots) => {
//     const studentTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

//     return slots.map((slot) => {
//       // const duration = slot.duration || 60;
//       const startLocal = moment.utc(slot.utcTime).tz(studentTimeZone);
//       const endLocal = moment(startLocal).add(slot.booking_duration, "minutes");
//       console.log(slot.booking_duration);
//       return {
//         ...slot,
//         booking_date: startLocal.format("YYYY-MM-DD"),
//         // start_time: startLocal.format("hh:mm A"),
//         // end_time: endLocal.format("hh:mm A"),
//         time_zone: studentTimeZone,
//       };
//     });
//   };

//   const columnHelper = createMRTColumnHelper();
//   const columns = [
//     columnHelper.accessor("counselorName", {
//       header: "Counselor Name",
//     }),

//     // columnHelper.accessor("request_by", {
//     //   header: "Requested By",
//     //   size: 30,
//     //   Cell: (cell) => cell.row.original.request_by,
//     // }),
//     // columnHelper.accessor("approved_by", {
//     //   header: "Approved By",
//     //   size: 30,
//     //   Cell: (cell) => cell.row.original.approved_by,
//     // }),
//     columnHelper.accessor("type", {
//       header: "Service Type",
//       size: 30,
//       Cell: (cell) => cell.row.original.type,
//     }),
//     columnHelper.accessor("reason", {
//       header: "Reason",
//       size: 30,
//       Cell: (cell) => cell.row.original.reason,
//     }),
//     // columnHelper.accessor("date", {
//     //   header: "Slot Date",
//     //   size: 30,
//     //   Cell: (cell) => cell.row.original.date,
//     // }),
//     columnHelper.accessor("booking_date", {
//       header: "Slot Date",
//       size: 30,
//       Cell: (cell) => cell.row.original.booking_date,
//     }),

//     // columnHelper.accessor("booking_date", {
//     //   header: "Slot Date",
//     //   Cell: (cell) => {
//     //     const date = cell.row.original?.booking_date;
//     //     return date ? new Date(date).toLocaleDateString("en-IN") : "N/A";
//     //   },
//     // }),

//     // columnHelper.accessor("created_at", {
//     //   header: "Slot Date",
//     //   size: 30,
//     //   Cell: (cell) => {
//     //     const rawDate = cell.row.original?.created_at;
//     //     if (!rawDate) return "N/A";

//     //     const dateObj = new Date(rawDate);
//     //     const day = String(dateObj.getDate()).padStart(2, "0");
//     //     const month = String(dateObj.getMonth() + 1).padStart(2, "0");
//     //     const year = dateObj.getFullYear();

//     //     return `${day}-${month}-${year}`;
//     //   },
//     // }),
//     columnHelper.accessor("formattedReqId", {
//       header: "Request ID",
//     }),
//   ];

//   columns.unshift(
//     columnHelper.accessor("actions", {
//       header: "Actions",
//       Cell: ({ cell }) => {
//         const id = cell.row.original.id;
//         const status = cell.row.original.status;

//         const handleApprove = () => {
//           Swal.fire({
//             html: `<div style="font-size: 30px; font-weight: bold;">Are you sure?</div>`,
//             text: "Do you want to approve this reschedule request?",
//             icon: "question",
//             showCancelButton: true,
//             confirmButtonText: "Yes, Approve",
//             cancelButtonText: "Cancel",
//             confirmButtonColor: "#3085d6",
//             cancelButtonColor: "#d33",
//           }).then((result) => {
//             if (result.isConfirmed) {
//               axios
//                 .get(`${baseUrl}/api/reschedule/student/approved/${id}`, {
//                   headers: {
//                     Authorization: `Bearer ${token}`, // assume token from session
//                   },
//                 })
//                 .then((res) => {
//                   Swal.fire(
//                     "Approved!",
//                     "Reschedule has been approved.",
//                     "success"
//                   );
//                   RescheduledBookings(); // reload updated data
//                 })
//                 .catch((err) => {
//                   Swal.fire(
//                     "Error!",
//                     err.response?.data?.message || "Failed to approve request.",
//                     "error"
//                   );
//                 });
//             }
//           });
//         };

//         return (
//           <Box display="flex" alignItems="center" gap={1}>
//             {status == 0 ? (
//               <Button
//                 variant="contained"
//                 size="small"
//                 color="error"
//                 onClick={handleApprove}
//                 sx={{ textTransform: "none", p: 1 }}
//               >
//                 Agree
//                 {/* Approve */}
//               </Button>
//             ) : (
//               <span style={{ color: "green" }}>Approved</span>
//             )}
//           </Box>
//         );
//       },
//     })
//   );

//   return (
//     <MasterLayout>
//       <CustomTable columns={columns} data={bookings} loading={loading} />
//     </MasterLayout>
//   );
// };

// export default StudentReScheduledBookingList;
